import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=05e53d46&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=05e53d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e53d46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e53d46')) {
      api.createRecord('05e53d46', component.options)
    } else {
      api.reload('05e53d46', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=05e53d46&scoped=true&", function () {
      api.rerender('05e53d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2po2wJ9001te8/JS/comp/DocBox.vue"
export default component.exports